import {SYSTEMSETTING} from 'Constants/ActionTypes';

const {
  GET_CALLING_NUMBER_LIST,
  SET_CALLING_NUMBER_PAGE_STATUS,
  SET_CALLING_NUMBER_EDIT_MODAL_DATA,
  EDIT_CALLING_NUMBER,
  DELETE_CALLING_NUMBER,
  TASK_LIST_DEPT,
  GET_ADMINISTRATORS,
} = SYSTEMSETTING;
// 通用前缀
const url = '/robot';

const actions = {
  // 权限控制
  getAdministrators() {
    return {
      type: GET_ADMINISTRATORS,
      payload: {
        request: {
          method: 'get',
          url: `/robot/dataDict/administrators`,
        },
      },
    };
  },
  // 系统设置-主叫号码-列表
  getTableList(data) {
    return {
      type: GET_CALLING_NUMBER_LIST,
      payload: {
        request: {
          method: 'post',
          url: `${url}/phone/list`,
          data,
        },
      },
    };
  },
  // 任务管理-任务列表-编辑弹框-点击确定
  queryDeptTree(vccId) {
    return {
      type: TASK_LIST_DEPT,
      payload: {
        request: {
          method: 'get',
          url: `/department/robot/queryTree?vccId=${vccId}`,
        },
      },
    };
  },
  // 系统设置-主叫号码-设置pageNum与pageSize
  setPageStatus(data) {
    return {
      type: SET_CALLING_NUMBER_PAGE_STATUS,
      data,
    };
  },
  // 系统设置-主叫号码-设置编辑弹框数据
  setEditModalData(data) {
    return {
      type: SET_CALLING_NUMBER_EDIT_MODAL_DATA,
      data,
    };
  },
  // 系统设置-主叫号码-编辑弹框-点击确定
  editCallingNumber(data) {
    return {
      type: EDIT_CALLING_NUMBER,
      payload: {
        request: {
          method: 'post',
          url: `${url}/phone/upsert`,
          data,
        },
      },
    };
  },
  // 系统设置-主叫号码-删除
  deleteCallingNumber(data) {
    return {
      type: DELETE_CALLING_NUMBER,
      payload: {
        request: {
          method: 'delete',
          url: `${url}/phone/delete/${data.id}`,
        },
      },
    };
  },
};

export default actions;
